//@flow
import React from "react"
import { FormattedMessage } from "react-intl"
import { Flex, Box } from "grid-styled"
import { Layer } from "../UI/Page"
import { SearchListView } from "../SearchTableView"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityPrimaryLink,
  EntityAction
} from "../UI/EntityList"
import { H2 } from "../UI/Headings"
import { queries } from "../Users"
import type { UserListQuery } from "../Users"

type SectionProps = {
  push: Function
}

type UserListProps = {
  users: UserListQuery,
  handleSearch: Function,
  searchName: string,
  push: Function
}

const UserList = ({
  users: { users, loading },
  handleSearch,
  searchName,
  push
}: UserListProps) => (
  <SearchListView
    handleSearch={handleSearch}
    searchName={searchName}
    query={searchName}
    entityName="Users"
    loading={loading}
  >
    <EntityHeading>
      <EntityDetail grow={2}>Name</EntityDetail>
      <EntityDetail grow={1}>Email</EntityDetail>
      <EntityDetail grow={1} shrink={0} />
    </EntityHeading>
    {users &&
      users.map(user => (
        <Entity key={user.id}>
          <EntityDetail grow={2}>
            <EntityPrimaryLink to={`/admin/users/${user.id || "new"}`}>
              {user.name}
            </EntityPrimaryLink>
          </EntityDetail>
          <EntityDetail grow={1}>{user.email}</EntityDetail>
          <EntityDetail grow={1} shrink={0} row end>
            <EntityAction
              href="#"
              onClick={() => push(`/admin/users/${user.id || "new"}`)}
              icon="✏️"
            />
          </EntityDetail>
        </Entity>
      ))}
  </SearchListView>
)

const UserListWithData = queries.withUsers(UserList)

type State = { query: string }

class UsersSection extends React.Component<SectionProps, State> {
  props: SectionProps

  constructor(props: SectionProps) {
    super(props)
    this.state = { query: "" }
  }

  handleSearch = (query: string) => this.setState(() => ({ query }))

  render() {
    const { push } = this.props
    const { query } = this.state

    return (
      <Layer>
        <Flex w="100%" wrap>
          <Box w={[1, 1 / 2, 1 / 3, null]} pr={[0, 2]}>
            <H2>
              <FormattedMessage id="admin.dashboard.users.title" />
            </H2>
            <p>
              <FormattedMessage id="admin.dashboard.users.description" />
            </p>
          </Box>
          <Box w={[1, 1 / 2, 2 / 3]}>
            <UserListWithData
              push={push}
              searchName={query}
              handleSearch={this.handleSearch}
            />
          </Box>
        </Flex>
      </Layer>
    )
  }
}

export default UsersSection



// WEBPACK FOOTER //
// ./src/Home/UsersSection.js